import React, { createContext, useState } from 'react';

const CountryContext = createContext(null);

function CountryContextProvider(props) {
  const [country, setCountry] = useState(null);

  return (
    <CountryContext.Provider
      value={{
        country: country || JSON.parse(localStorage.getItem('current_country')),
        setCountry: setCountry,
      }}
    >
      {props.children}
    </CountryContext.Provider>
  );
}

export { CountryContextProvider, CountryContext as countryContext };
